import { Icon, IconProps } from "@chakra-ui/react";

const LinkedInColorIcon = ({ color = "#0069C6", ...props }: IconProps) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      color={color}
      {...props}
    >
      <path
        d="M7.32547 20.5H3.80906V9.1546H7.32547V20.5ZM5.56444 7.60676C5.15847 7.60942 4.76084 7.4914 4.42191 7.26764C4.08299 7.04389 3.81802 6.72446 3.66055 6.34983C3.50309 5.97519 3.46023 5.5622 3.53738 5.16315C3.61454 4.7641 3.80825 4.39696 4.09398 4.10822C4.37971 3.81947 4.7446 3.62212 5.14244 3.54115C5.54029 3.46019 5.95318 3.49925 6.32883 3.6534C6.70449 3.80754 7.026 4.06983 7.25264 4.40705C7.47929 4.74427 7.60088 5.14124 7.602 5.54769C7.6024 6.09061 7.38846 6.61168 7.0068 6.99736C6.62514 7.38305 6.1067 7.60209 5.56444 7.60676ZM20.4965 20.5H16.985V14.9771C16.985 13.6608 16.9581 11.9727 15.1554 11.9727C13.3257 11.9727 13.0457 13.403 13.0457 14.8822V20.5H9.52995V9.1546H12.9049V10.7024H12.9544C13.292 10.1241 13.7799 9.64823 14.3663 9.32564C14.9527 9.00305 15.6155 8.84581 16.2841 8.87066C19.8451 8.86996 20.5 11.2179 20.5 14.2676V20.4986L20.4965 20.5Z"
        fill="currentColor"
      />
    </Icon>
  );
};
export default LinkedInColorIcon;
